module.exports = __webpack_public_path__ + "./img/mountain-big.svg";